export default __webpack_public_path__ + "static/media/Powered-stripe-blurple.d9e57232.svg";